/* collection-description.js - mobile (<750px) 2-line clamp of the collection
   description with a "Więcej" / "Mniej" toggle (03-10). The full text stays in
   the HTML; the clamp class is added here, so without JS everything is visible.
   The toggle button carries aria-expanded. textContent only. */
(function () {
  'use strict';

  var intro = document.querySelector('[data-collection-intro]');
  if (!intro || !window.matchMedia) return;
  var text = intro.querySelector('.collection-header__description');
  var button = intro.querySelector('[data-intro-toggle]');
  if (!text || !button) return;

  var query = window.matchMedia('(max-width: 749px)');
  var expanded = false;

  function update() {
    if (!query.matches) {
      intro.classList.remove('is-clamped');
      button.hidden = true;
      return;
    }
    if (expanded) {
      intro.classList.remove('is-clamped');
      button.hidden = false;
      return;
    }
    intro.classList.add('is-clamped');
    // Only offer the toggle when the text is actually cut off.
    button.hidden = !(text.scrollHeight > text.clientHeight + 1);
  }

  button.addEventListener('click', function () {
    expanded = !expanded;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
    update();
  });

  if (query.addEventListener) query.addEventListener('change', update);
  else if (query.addListener) query.addListener(update);
  update();
})();
